export default "/images/vendor/flag-icon-css/flags/4x3/ng.svg?f29450b9f8b2f04e96aaa39902099e9c";